// social-buttons.js — entry-screen [channel-toggle] [Google] [Apple] row
import React from 'react'
import { useGoogleLogin } from '@react-oauth/google'
import { useAuthContext } from './reducer'
import { generateNonce } from '../../services/oauth/nonce'
import { appleSignIn } from '../../services/oauth/apple'
import { SocialButtonsRow } from './styles'

const AppleIcon = () => (
  <svg className="apple-icon" viewBox="0 0 384 512" width="18" height="18" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C71.5 141.2 16 189.3 16 287.4c0 29 5.3 59 15.9 89.9 14.2 40.6 65.5 140.1 119 138.5 28-1.3 47.8-20.6 84.3-20.6 35.4 0 53.7 20.6 84.9 20.6 54 0 100.4-90.4 114-131.1-72.5-34.2-68.4-100.1-68.4-116zM255 105c30.8-36.5 28-69.8 27.1-81.8-27.2 1.6-58.7 18.6-76.7 39.5-19.7 22.4-31.3 50-28.8 79.4 29.5 2.3 56.4-12.9 78.4-37.1z"
    />
  </svg>
)

const GoogleIcon = () => (
  <svg className="google-icon" viewBox="0 0 48 48" width="18" height="18" aria-hidden="true" focusable="false">
    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
    <path fill="#FBBC05" d="M11.69 28.18c-.44-1.32-.69-2.73-.69-4.18s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z" />
    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
  </svg>
)

export const SocialButtons = ({ switchChannel, onProviderCredential }) => {
  const { state } = useAuthContext()
  const isEmail = state.otpChannel === 'email'

  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: ({ code }) => onProviderCredential('google', { code }),
    onError: () => {},
  })

  const handleApple = async () => {
    // generate the nonce at click-time (browser only) — never during SSR render
    const credential = await appleSignIn(generateNonce()).catch(() => null)
    if (credential?.idToken) {
      onProviderCredential('apple', credential)
    }
  }

  return (
    <SocialButtonsRow>
      <button type="button" className="social-button" onClick={switchChannel}>
        {isEmail ? 'Phone' : 'Email'}
      </button>

      <button type="button" className="social-button google-button" onClick={() => googleLogin()}>
        <GoogleIcon />
        Google
      </button>
      <button type="button" className="social-button apple-button" onClick={handleApple}>
        <AppleIcon />
        Apple
      </button>
    </SocialButtonsRow>
  )
}
